/**
 * Radio-style filters
 */

document.querySelectorAll('.filter--radio')?.forEach((filter) => {
	// cache things
	const clear = filter.querySelector('.filter__all');
	const boxes = filter.querySelectorAll('.filter__box');

	// on click of clear all
	clear.addEventListener('click', () => {
		// clear all selected boxes
		boxes.forEach((box) => {
			box.checked = false;
		});
		// navigate to designated initial page
		window.location = filter.dataset.filterAllUrl;
	});

	// handle radio-button-like functionality (only one active at a time)
	boxes.forEach((box) => {
		box.addEventListener('change', () => {
			boxes.forEach((step) => (step.checked = false));
			box.checked = true;
		});
	});

	// have "clear" button simply navigate to designated initial page
	boxes.forEach((box) => {
		box.addEventListener('change', () => {
			window.location = box.nextElementSibling.dataset.filterUrl;
		});
	});
});
